import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './UpsellProgressBar.css';

const cx = classnames.bind(styles);

const STEPS = [
    { id: 1, label: 'Buy Plan' },
    { id: 2, label: 'Add offer' },
    { id: 3, label: 'Start your story' }
];

function UpsellProgressBar({ currentStep, className = '' }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <ol className={styles.steps}>
                {STEPS.map(step => (
                    <li
                        key={step.id}
                        className={cx('step', { completed: step.id < currentStep, active: step.id === currentStep })}
                    >
                        <span className={styles.label}>{step.label}</span>
                        <div className={styles.stepRow}>
                            <div className={styles.lineLeft} />
                            <div className={styles.circle}>
                                {step.id < currentStep && <Icon name='checkTick' className={styles.checkIcon} />}
                            </div>
                            <div className={styles.lineRight} />
                        </div>
                    </li>
                ))}
            </ol>
        </div>
    );
}

UpsellProgressBar.propTypes = {
    currentStep: PropTypes.number.isRequired,
    className: PropTypes.string
};

export {
    UpsellProgressBar
};
